App.controller('LifeWithPaymentsFormCtrl', ['$scope', '$rootScope', '$sce', '$state', 'lifeInsuranceWithPaymentsService', 'popUpService', '$stateParams', 'profileService', 'statesService', 'branchService', '$q', '$filter', '$timeout', '$anchorScroll', '$location', function ($scope, $rootScope, $sce, $state, lifeInsuranceWithPaymentsService, popUpService, $stateParams, profileService, statesService, branchService, $q, $filter, $timeout, $anchorScroll, $location) {

    function LifeWithPaymentsFormCtrl() {
        $scope.stateParams = $stateParams;

        $scope.maxDate = new Date();

        $scope.page = 'life';
        $scope.$emit('page', $scope.page);

        $scope.step = 'Wybierz wariant ubezpieczenia';
        $scope.$emit('step', $scope.step);

        $scope.link = 'root.life.variant';
        $scope.$emit('link', $scope.link);

        if (lifeInsuranceWithPaymentsService.isUnum()) {
            $scope.lifeInsurapartnerHintnceWithPaymentsContent = "Aby partner życiowy mógł przystąpić do ubezpieczenia (wypełnić wniosek)," +
                "należy wskazać go najpierw we wniosku Ubezpieczonego Głównego.";
            $scope.announcement = "";
        } else if (lifeInsuranceWithPaymentsService.isPzu()) {
            $scope.partnerHint = 'Wskazanie partnera życiowego sprawia, że jest on traktowany ' +
                'na równi z małżonkiem – w przypadku wypłaty świadczenia za zgon małżonka lub rodziców małżonka.';
            $scope.announcement = "Małżonek i pełnoletnie dzieci przystępują, rejestrując własne Konto Użytkownika.";
        } else {
            $scope.announcement = "";
        }

        if ($scope.stateParams.choose && $scope.stateParams.prices) {
            $scope.person = $scope.stateParams.person;
            $scope.persons = $scope.stateParams.persons;
            $scope.choose = $scope.stateParams.choose;
            $scope.prices = $scope.stateParams.prices;
            $scope.partner = $scope.stateParams.partner;
            $scope.assured = $scope.stateParams.assured;
            $scope.summary = $scope.stateParams.summary;
            $scope.isAssured = {
                value: $scope.stateParams.isAssured
            };
            $scope.isPartner = {
                value: $scope.stateParams.isPartner
            };
        } else {
            $state.go('root.life.variant');
            return;
        }

        let hasActiveDeclaration = !!$rootScope.__logged;
        let hasReadyDeclaration = !!$rootScope.__logged;
        let hasEnteredDeclaration = !!$rootScope.__logged;

        $scope.availableLifePackages = [];
        $scope.groupColors = ['', 'beige', 'powderblue', 'aliceblue'];
        $scope.isLifePackageDisabled = function (id) {
            return _.find($scope.availableLifePackages, function (e) {
                return e === id;
            }) === undefined;
        };

        if ($rootScope.__logged) {
            lifeInsuranceWithPaymentsService.available().then(function (data) {
                $scope.availableLifePackages = data.data.availableLifePackages;
                hasActiveDeclaration = data.data.hasActiveDeclaration;
                hasReadyDeclaration = data.data.hasReadyDeclaration;
                hasEnteredDeclaration = data.data.hasEnteredDeclaration;
                if (!$scope.canCompleteDeclaration()) {
                    popUpService.showPopUpBigInfo('', '', 'Aby zmienić dane lub zaprosić członków rodziny, wejdź w zakładkę Moje deklaracje.', 'Ok', 'root.life.list');
                }
            });
        }

        let userObject = window.sessionStorage.getItem('userObject');
        if (userObject) {
            $scope.userObject = JSON.parse(userObject);
            let userObjectCopy = angular.copy($scope.userObject);
            $scope.person = angular.merge(userObjectCopy.person, {
                address: ($scope.person ? $scope.person.address : {}) || {}
            });
            $scope.person.branch = userObjectCopy.branch;

            if ($scope.userObject.person.citizenshipType !== 'POLISH') {
                $scope.person.gender = 'FEMALE';
            }

            if (userObjectCopy.employmentDate) {
                $scope.person.employmentDate = userObjectCopy.employmentDate;
            }

            if ($scope.stateParams.person && $scope.stateParams.person.employmentDate) {
                $scope.person.employmentDate = new Date($scope.stateParams.person.employmentDate);
            }

        } else if (!$scope.person) {
            $scope.person.citizenshipType = 'POLISH';
        }

        $scope.canCompleteDeclaration = function () {
            if (lifeInsuranceWithPaymentsService.isPzu()) {
                return !hasReadyDeclaration;
            } else {
                return !hasActiveDeclaration && !hasReadyDeclaration;
            }
        };

        if (validateAge($scope.userObject.person, $filter('proposedDate')('life'))) {
            lifeInsuranceWithPaymentsService.sendStatements($scope.choose);
        } else {
            return;
        }

        lifeInsuranceWithPaymentsService.getAllPackages().then(function (data) {
            $scope.lifePackages = data.data.group;
        });

        if (!$scope.partner) {
            $scope.partner = {
                citizenshipType: 'POLISH',
                gender: "FEMALE",
                birthdate: null
            };
        }
        if (!$scope.assured) {
            $scope.assured = [createAssured()];
        }

        $scope.addAssured = function () {
            if ($scope.assured.length < 4) {
                $scope.assured.push(createAssured());
            }
        };

        function createAssured() {
            let assured = {
                type: 'PERSON',
                country: 'POLISH',
                personBirthdate: null,
            };

            if (lifeInsuranceWithPaymentsService.isPzu()) {
                assured.sameAddress = true;
                assured.city = $scope.person.address.city;
                assured.street = $scope.person.address.street;
                assured.number = $scope.person.address.number;
                assured.apartment = $scope.person.address.apartment;
                assured.zipCode = $scope.person.address.zipCode;
            }

            return assured;
        }

        $scope.deleteAssured = function (obj) {
            $scope.assured.splice(obj, 1);
        };

        $scope.accept = function () {
            console.log('accept', $scope.form, $scope.person);
            $scope.form.$setSubmitted();
            $scope.next($scope.form);
        };

        $scope.next = function () {
            let vm = this;

            if (!vm.form.$valid) {
                popUpService.showPopUpBigInfo('', 'Aby zapisać wniosek, oznacz wszystkie wymagane pola (oznaczone gwiazdką).');
                document.body.scrollTop = document.documentElement.scrollTop = 80;
                return 0;
            }

            if (!$scope.canCompleteDeclaration()) {
                return;
            }
            if (!Object.keys($scope.choose[0]).length) {
                popUpService.showPopUpBigInfo('', 'Dokonaj wyboru wariantu ubezpieczenia', 'Aby kontynuować zaznacz minimum jeden wariant ubezpieczenia Życie i Zdrowie.');
                return 0;
            }

            let isPercentageValid = $filter('percentageOfBenefit')($scope.isAssured.value ? $scope.assured : []);
            if (!isPercentageValid) {
                popUpService.showPopUpBigInfo('', 'Nieprawidłowy procent świadczenia', 'Procent świadczenia dla wszystkich uposażonych musi się sumować do 100%');
                return;
            }

            let params = {
                choose: $scope.choose,
                prices: $scope.prices,
                summary: $scope.summary,
                assured: $scope.assured,
                partner: $scope.partner,
                person: $scope.person,
                persons: $scope.persons,
                isAssured: $scope.isAssured.value,
                isPartner: $scope.isPartner.value
            };

            params.person.employmentDate = $filter('getDateFromBirthdate')($scope.person.employmentDate);
            params.person.marriageDate = $filter('getDateFromBirthdate')($scope.person.marriageDate);

            $state.go('root.life.confirmation', params);
        };

        /**
         * Scroll to inputs on init;
         */
        (function () {
            $timeout(function () {
                // Always scroll by 70 extra pixels (navbar height)
                $anchorScroll.yOffset = 70;
                $location.hash('form');
            });
        })();

        function validateAge(person, proposedDate) {
            if ($filter('isOver69AtDateFromBirthdate')(new Date(person.birthdate), new Date(proposedDate))) {
                popUpService.showPopUpBigInfo('', 'Brak możliwości przystąpienia do ubezpieczenia',
                    'Do ubezpieczenia mogą przystąpić wyłącznie osoby, które na dzień rozpoczęcia ochrony ubezpieczeniowej nie ukończyły 69 lat.',
                    'Ok', 'root.life.start');
                return 0;
            }
            return 1;
        }


        $scope.$watch('person', function (newVal, oldVal) {
            if (oldVal !== newVal) {
                for (let a = 0; a < $scope.assured.length; a++) {
                    if ($scope.assured[a].sameAddress) {
                        $scope.assured[a].city = $scope.person.address.city;
                        $scope.assured[a].street = $scope.person.address.street;
                        $scope.assured[a].number = $scope.person.address.number;
                        $scope.assured[a].apartment = $scope.person.address.apartment;
                        $scope.assured[a].zipCode = $scope.person.address.zipCode;
                    }
                }
            }
        }, true);

        $scope.$watch('assured', function (newVal, oldVal) {
            if (oldVal !== newVal) {
                for (let a = 0; a < $scope.assured.length; a++) {
                    if ($scope.assured[a].type !== 'ORGANIZATION' && $scope.assured[a].sameAddress) {
                        $scope.assured[a].city = $scope.person.address.city;
                        $scope.assured[a].street = $scope.person.address.street;
                        $scope.assured[a].number = $scope.person.address.number;
                        $scope.assured[a].apartment = $scope.person.address.apartment;
                        $scope.assured[a].zipCode = $scope.person.address.zipCode;
                    }
                }
            }
        }, true);
    }

    return new LifeWithPaymentsFormCtrl();
}]);

